export const BANNER_COOKIE = Object.freeze({
  READ_ONLY_ROLE_BANNER_CLOSED: "read-only-role-banner-closed",
  LEGACY_MIGRATION_BANNER_CLOSED: "legacy-migration-banner-closed",
  SFI_MIGRATION_BANNER_CLOSED_PREFIX: "sfi-migration-banner-closed",
});

export const getSfiMigrationBannerCookieName = (customerId) =>
  customerId
    ? `${BANNER_COOKIE.SFI_MIGRATION_BANNER_CLOSED_PREFIX}-${customerId}`
    : BANNER_COOKIE.SFI_MIGRATION_BANNER_CLOSED_PREFIX;

export default {};
